"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var saveReadingPaneOption_1 = require("../actions/saveReadingPaneOption");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var ReadingPanePosition_1 = require("owa-session-store/lib/store/schema/ReadingPanePosition");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var ReadingPaneQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneQuick, _super);
    function ReadingPaneQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            var newReadingPanePosition = parseInt(option.key, 10);
            saveReadingPaneOption_1.saveReadingPaneOptionQuick(newReadingPanePosition);
        };
        return _this;
    }
    ReadingPaneQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var options = [
            {
                key: "" + ReadingPanePosition_1.default.Right,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_right,
            },
            {
                key: "" + ReadingPanePosition_1.default.Bottom,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_bottom,
            },
            {
                key: "" + ReadingPanePosition_1.default.Off,
                text: owa_options_strings_1.default.options_readingPane_quickSetting_classic,
            },
        ];
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: "" + userOptions.GlobalReadingPanePositionReact, options: options, onChange: this.onChange }));
    };
    ReadingPaneQuick = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ReadingPaneQuick);
    return ReadingPaneQuick;
}(React.Component));
exports.default = ReadingPaneQuick;
//# sourceMappingURL=ReadingPaneQuick.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/components/ReadingPaneQuick.js
// module id = 5114
// module chunks = 2